<main>
  <h1 class="text-display-md text-extrabold">
    Shadows
  </h1>

  <section class="box-wrapper">
    <div class="testing-box border-gray-50 xs-shadow">
      <span class="text-heading-lg text-bold">XS</span>
    </div>

    <div class="testing-box border-gray-50 sm-shadow">
      <span class="text-heading-lg text-bold">SM</span>
    </div>

    <div class="testing-box border-gray-50 md-shadow">
      <span class="text-heading-lg text-bold">MD</span>
    </div>

    <div class="testing-box border-gray-50 lg-shadow">
      <span class="text-heading-lg text-bold">LG</span>
    </div>

    <div class="testing-box border-gray-50 xl-shadow">
      <span class="text-heading-lg text-bold">XL</span>
    </div>

    <div class="testing-box border-gray-50 xl2-shadow">
      <span class="text-heading-lg text-bold">2XL</span>
    </div>
  </section>

  <h1 class="text-display-md text-extrabold">
    Blurs
  </h1>

  <section class="box-wrapper bg-blue-200 p-10">
    <div class="testing-box blur-sm-light">
      <span class="text-gray-900 text-heading-lg text-bold">SM light</span>
    </div>

    <div class="testing-box blur-md-light">
      <span class="text-gray-900 text-heading-lg text-bold">MD light</span>
    </div>

    <div class="testing-box blur-lg-light">
      <span class="text-gray-900 text-heading-lg text-bold">LG light</span>
    </div>

    <div class="testing-box blur-sm-dark">
      <span class="text-gray-50 text-heading-lg text-bold">SM dark</span>
    </div>

    <div class="testing-box blur-md-dark">
      <span class="text-gray-50 text-heading-lg text-bold">MD dark</span>
    </div>

    <div class="testing-box blur-lg-dark">
      <span class="text-gray-50 text-heading-lg text-bold">LG dark</span>
    </div>
  </section>

  <h1 class="text-display-md text-extrabold">
    Opacity
  </h1>

  <section class="box-wrapper bg-blue-200 p-10">
    <div class="testing-box opacity-full-light">
      <span class="text-gray-900 text-heading-lg text-bold">SM light</span>
    </div>

    <div class="testing-box opacity-sm-light">
      <span class="text-gray-900 text-heading-lg text-bold">MD light</span>
    </div>

    <div class="testing-box opacity-md-light">
      <span class="text-gray-900 text-heading-lg text-bold">LG light</span>
    </div>

    <div class="testing-box opacity-lg-light">
      <span class="text-gray-900 text-heading-lg text-bold">LG light</span>
    </div>

    <div class="testing-box opacity-full-dark">
      <span class="text-gray-50 text-heading-lg text-bold">SM dark</span>
    </div>

    <div class="testing-box opacity-sm-dark">
      <span class="text-gray-50 text-heading-lg text-bold">MD dark</span>
    </div>

    <div class="testing-box opacity-md-dark">
      <span class="text-gray-50 text-heading-lg text-bold">LG dark</span>
    </div>

    <div class="testing-box opacity-lg-dark">
      <span class="text-gray-50 text-heading-lg text-bold">LG dark</span>
    </div>
  </section>

  <h1 class="text-display-md text-extrabold">
    Borders
  </h1>

  <section class="box-wrapper">
    <div class="testing-box border-sm-full border-red-500">
      SM full
    </div>

    <div class="testing-box border-sm-top border-red-500">
      SM top
    </div>

    <div class="testing-box border-sm-bottom border-red-500">
      SM bottom
    </div>

    <div class="testing-box border-sm-left border-red-500">
      SM left
    </div>

    <div class="testing-box border-sm-right border-red-500">
      SM right
    </div>

    <div class="testing-box border-sm-top border-sm-right border-red-500">
      SM top right
    </div>

    <div class="testing-box border-sm-bottom border-sm-right border-red-500">
      SM bottom right
    </div>

    <div class="testing-box border-sm-top border-sm-left border-red-500">
      SM top left
    </div>

    <div class="testing-box border-sm-bottom border-sm-left border-red-500">
      SM bottom left
    </div>

    <div class="testing-box">
      SM 0
    </div>
  </section>

  <section class="box-wrapper">
    <div class="testing-box border-md-full border-blue-500">
      MD full
    </div>

    <div class="testing-box border-md-top border-blue-500">
      MD top
    </div>

    <div class="testing-box border-md-bottom border-blue-500">
      MD bottom
    </div>

    <div class="testing-box border-md-left border-blue-500">
      MD left
    </div>

    <div class="testing-box border-md-right border-blue-500">
      MD right
    </div>

    <div class="testing-box border-md-top border-md-right border-blue-500">
      MD top right
    </div>

    <div class="testing-box border-md-bottom border-md-right border-blue-500">
      MD bottom right
    </div>

    <div class="testing-box border-md-top border-md-left border-blue-500">
      MD top left
    </div>

    <div class="testing-box border-md-bottom border-md-left border-blue-500">
      MD bottom left
    </div>

    <div class="testing-box">
      MD 0
    </div>
  </section>

  <section class="box-wrapper">
    <div class="testing-box border-lg-full border-orange-400">
      LG full
    </div>

    <div class="testing-box border-lg-top border-orange-400">
      LG top
    </div>

    <div class="testing-box border-lg-bottom border-orange-400">
      LG bottom
    </div>

    <div class="testing-box border-lg-left border-orange-400">
      LG left
    </div>

    <div class="testing-box border-lg-right border-orange-400">
      LG right
    </div>

    <div class="testing-box border-lg-top border-lg-right border-orange-400">
      LG top right
    </div>

    <div class="testing-box border-lg-bottom border-lg-right border-orange-400">
      LG bottom right
    </div>

    <div class="testing-box border-lg-top border-lg-left border-orange-400">
      LG top left
    </div>

    <div class="testing-box border-lg-bottom border-lg-left border-orange-400">
      LG bottom left
    </div>

    <div class="testing-box">
      LG 0
    </div>
  </section>

  <h1 class="text-display-md text-extrabold">
    Corners
  </h1>

  <section class="box-wrapper">
    <div class="testing-box border-lg-full border-gray-400 rounded-xs">
      XS
    </div>

    <div class="testing-box border-lg-full border-gray-400 rounded-sm">
      SM
    </div>

    <div class="testing-box border-lg-full border-gray-400 rounded-md">
      MD
    </div>

    <div class="testing-box border-lg-full border-gray-400 rounded-lg">
      LG
    </div>

    <div class="testing-box border-lg-full border-gray-400 rounded-xl">
      XL
    </div>
  </section>

  <h1 class="text-display-md text-extrabold">
    Background
  </h1>

  <section class="box-wrapper rounded-xs">
    <div class="testing-box bg-tint-1">
      <span class="text-gray-900 text-heading-lg text-bold">Tint1</span>
    </div>

    <div class="testing-box bg-tint-2 rounded-xs">
      <span class="text-gray-900 text-heading-lg text-bold">Tint2</span>
    </div>

    <div class="testing-box bg-tint-3 rounded-xs">
      <span class="text-gray-50 text-heading-lg text-bold">Tint3</span>
    </div>

    <div class="testing-box bg-tint-4 rounded-xs">
      <span class="text-gray-50 text-heading-lg text-bold">Tint4</span>
    </div>

    <div class="testing-box bg-tint-5 rounded-xs">
      <span class="text-gray-50 text-heading-lg text-bold">Tint5</span>
    </div>

    <div class="testing-box bg-tint-6 rounded-xs">
      <span class="text-gray-50 text-heading-lg text-bold">Tint6</span>
    </div>
  </section>
</main>